// extracted by mini-css-extract-plugin
module.exports = {"title-header":"ProfilePage_title-header__2bXEY","reviewer-center-container":"ProfilePage_reviewer-center-container__3OkA3"};